import { Button, Radio } from 'antd';
import { useTranslation } from 'react-i18next';

import {
  CustomFilterContainer,
  CustomFilterPopover,
  FilterActions,
} from 'components/data/helpers/filters.style';
import { type CustomFilterDropdownProps } from 'horizon/types/TableColumnDef';

import { NextInspectionDueOptions } from './NextInspectionDueFilter.style';
import {
  type NextInspectionDueOptionId,
  getNextInspectionDueOptionValue,
  getSelectedNextInspectionDueOption,
  NEXT_INSPECTION_DUE_OPTIONS,
} from './utils';

type Props = CustomFilterDropdownProps;

export const NextInspectionDueFilter = ({
  selectedKeys,
  setSelectedKeys,
  confirm,
  clearFilters,
}: Props) => {
  const { t } = useTranslation();
  const selectedOption = getSelectedNextInspectionDueOption(selectedKeys);

  const handleChange = (id: NextInspectionDueOptionId) => {
    setSelectedKeys(getNextInspectionDueOptionValue(id));
  };

  const handleConfirm = () => {
    confirm({ closeDropdown: true });
  };

  // Like the other filters, Reset applies at once: antd only applies a custom filter on confirm
  const handleReset = () => {
    clearFilters?.();
    setSelectedKeys([]);
    confirm({ closeDropdown: true });
  };

  return (
    <CustomFilterPopover className="ant-table-filter-dropdown" data-testid="next-due-filter">
      <CustomFilterContainer>
        <NextInspectionDueOptions
          value={selectedOption}
          onChange={(event) => handleChange(event.target.value)}
          aria-label={t('table.nextInspectionDue', 'Next Inspection Due')}
        >
          {NEXT_INSPECTION_DUE_OPTIONS.map(({ id, getLabel }) => (
            <Radio key={id} value={id}>
              {getLabel(t)}
            </Radio>
          ))}
        </NextInspectionDueOptions>
      </CustomFilterContainer>

      <FilterActions>
        <Button type="link" size="small" onClick={handleReset}>
          {t('table.reset', 'Reset')}
        </Button>
        <Button type="primary" size="small" onClick={handleConfirm}>
          {t('table.ok', 'OK')}
        </Button>
      </FilterActions>
    </CustomFilterPopover>
  );
};
